import * as React from 'react';
import DateTime from 'react-datetime';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import { assign } from '../../shared/Assign';
import FormSelect from '../../components/common/FormSelect';
import FormInputChangeHandler from '../../shared/form/FormInputChangeHandler';
import * as Features from '../../shared/Features';
import InvoiceHistoryList from './InvoiceHistoryList';
import CreatePaymentModal from './CreatePaymentModal';
import CreditInvoiceModal from './CreditInvoiceModal';
import ViewPaymentsModal from './ViewPaymentsModal';
import ViewCustomerInvoiceModal from './ViewCustomerInvoiceModal';
import * as actions from './InvoiceActions';
import InvoiceTypeLegend from './InvoiceTypeLegend';
import moment from 'moment';
import Loader from 'react-loader';

const date = new Date();
date.setMonth(date.getMonth() - 2);

class InvoiceHistoryPage extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            isLoading: false,
            searched: false,
            displayCreatePaymentModal: false,
            displayViewPaymentsModal: false,
            displayShowInvoiceModal: false,
            displayCreditInvoiceModal: false,
            selectedInvoice: null,

            paymentModalDate: new Date(),
            paymentModalAmountValue: null,

            filter: {
                invoiceNumber: '',
                invoiceStatus: '',
                invoiceType: '',
                invoiceDateType: 1,
                invoiceFromDate: date,
                invoiceToDate: '',
                brokerFirmId: ''
            }
        };
        this.onKeyPress = this.onKeyPress.bind(this);
        this.setFilterState = this.setFilterState.bind(this);
        this.downloadInvoice = this.downloadInvoice.bind(this);
        this.onFromDateTimeChange = this.onFromDateTimeChange.bind(this);
        this.onToDateTimeChange = this.onToDateTimeChange.bind(this);
        this.enableModal = this.enableModal.bind(this);
        this.disableModal = this.disableModal.bind(this);
        this.paymentModalSelectDate = this.paymentModalSelectDate.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.filter,
            this.setFilterState
        );
    }

    debounce(fn, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

    onFromDateTimeChange(value: any): void {
        let date = value.toDate();
        this.formInputChangeHandler.handleChange('invoiceFromDate', date);
    }

    onToDateTimeChange(value: any): void {
        let date = value.toDate();
        this.formInputChangeHandler.handleChange('invoiceToDate', date);
    }

    setFilterState(filter: any) {
        let newFilter = assign(this.state.filter, filter);
        this.setState({ filter: newFilter });
    }

    componentDidMount(): void {
        this.props.actions.getInvoicesFilter().catch((error: any) => handleError(error));
    }

    enableModal(displayPropertyName: string, invoiceId: number): void {
        const paymentModalAmountValue = this.getAmountFromInvoiceRest(invoiceId);

        this.setState({
            [displayPropertyName]: true,
            selectedInvoice: invoiceId,
            paymentModalAmountValue
        });
    }

    disableModal(displayPropertyName: string): void {
        this.setState({ [displayPropertyName]: false, selectedInvoice: null });
    }

    downloadInvoice(invoiceId: number): void {
        this.props.actions.downloadInvoice(invoiceId).catch((error: any) => handleError(error));
    }

    search(): void {
        this.setState({ searched: false, isLoading: true });
        this.props.actions
            .getInvoices(this.state.filter)
            .then(() =>
                this.setState({
                    searched: true,
                    isLoading: false
                })
            )
            .catch((error: any) => {
                this.setState({ isLoading: false });
                handleError(error);
            });
    }

    onKeyPress(target) {
        let key = target.key;
        if (key === 'Enter') {
            this.search();
        }
    }

    paymentModalSelectDate(date: Date) {
        this.setState({ paymentModalDate: date });
    }

    getAmountFromInvoiceRest(id: number): number {
        let rest = this.props.invoices.list
            .find(invoice => invoice.id === id).rest;

        if (!rest) rest = 0;

        return rest;
    }

    modalAmountValueChange = e => {
        this.setState({ paymentModalAmountValue: e.target.value });
    }

    render() {
        return (
            <div>
                <h1 className="col-xs-12">{Translate('invoice-history/title')}</h1>
                <fieldset>
                    <form>
                        <Row>
                            <Col sm={12} md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-number'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceNumber"
                                        value={this.state.filter.invoiceNumber}
                                        onChange={this.formInputChangeHandler.onChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-status'
                                        )}
                                    </ControlLabel>
                                    <FormSelect
                                        name="invoiceStatus"
                                        value={this.state.filter.invoiceStatus as any}
                                        onChange={this.formInputChangeHandler.onChange}
                                    >
                                        <option value=""></option>
                                        {this.props.filter.availableInvoiceStatuses.map(
                                            (s: any) => {
                                                return (
                                                    <option key={s.id} value={s.id as any}>
                                                        {Translate(s.name)}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </FormSelect>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-type'
                                        )}
                                    </ControlLabel>
                                    <FormSelect
                                        name="invoiceType"
                                        value={this.state.filter.invoiceType as any}
                                        onChange={this.formInputChangeHandler.onChange}
                                    >
                                        <option value=""></option>
                                        {this.props.filter.availableInvoiceTypes.map((s: any) => {
                                            return (
                                                <option key={s.id} value={s.id}>
                                                    {Translate(s.name)}
                                                </option>
                                            );
                                        })}
                                    </FormSelect>
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/customer'
                                        )}
                                    </ControlLabel>
                                    <FormSelect
                                        name="brokerFirmId"
                                        value={this.state.filter.brokerFirmId as any}
                                        onChange={this.formInputChangeHandler.onChange}
                                    >
                                        <option value=""></option>
                                        {this.props.filter.availableCustomers.map((s: any) => {
                                            return (
                                                <option key={s.id} value={s.id}>
                                                    {s.name}
                                                </option>
                                            );
                                        })}
                                    </FormSelect>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={4}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-datetype'
                                        )}
                                    </ControlLabel>
                                    <FormSelect
                                        name="invoiceDateType"
                                        value={this.state.filter.invoiceDateType as any}
                                        onChange={this.formInputChangeHandler.onChange}
                                    >
                                        {this.props.filter.availableInvoiceDateTypes.map(
                                            (s: any) => {
                                                return (
                                                    <option key={s.id} value={s.id}>
                                                        {Translate(s.name)}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </FormSelect>
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={4}>
                                <FormGroup className="required" required={true}>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-from-date'
                                        )}
                                    </ControlLabel>
                                    <DateTime
                                        input={true}
                                        locale={moment.locale()}
                                        value={this.state.filter.invoiceFromDate}
                                        timeFormat={false}
                                        onChange={this.debounce(this.onFromDateTimeChange, 1000)}
                                        closeOnSelect={true}
                                        inputProps={{ onKeyPress: this.onKeyPress }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={4}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate(
                                            'invoice-history/filter-form/input-label/invoice-to-date'
                                        )}
                                    </ControlLabel>
                                    <DateTime
                                        input={true}
                                        locale={moment.locale()}
                                        value={this.state.invoiceToDate}
                                        timeFormat={false}
                                        onChange={this.debounce(this.onToDateTimeChange, 1000)}
                                        closeOnSelect={true}
                                        inputProps={{
                                            onKeyPress: this.onKeyPress
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Button
                                    bsSize="large"
                                    onClick={() => this.search()}
                                    bsStyle="success"
                                >
                                    {Translate('invoice-history/search')}
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </fieldset>

                {this.state.isLoading && (
                    <div style={{ height: '50vh' }}>
                        <Row>
                            <Loader loaded={!this.state.isLoading}></Loader>
                        </Row>
                    </div>
                )}

                {this.state.searched && (
                    <Row>
                        <Col sm={3} smPush={9}>
                            <InvoiceTypeLegend />
                        </Col>
                        <InvoiceHistoryList
                            items={this.props.invoices.list}
                            showInvoice={(invoiceId) =>
                                this.enableModal('displayShowInvoiceModal', invoiceId)
                            }
                            creditInvoice={(invoiceId) =>
                                this.enableModal('displayCreditInvoiceModal', invoiceId)
                            }
                            createPayment={(invoiceId) =>
                                this.enableModal('displayCreatePaymentModal', invoiceId)
                            }
                            viewPayments={(invoiceId) =>
                                this.enableModal('displayViewPaymentsModal', invoiceId)
                            }
                            downloadInvoice={this.downloadInvoice}
                            canViewPayments={Features.hasFeature(
                                Features.ViewPayments,
                                this.props.user
                            )}
                            canCreatePayments={Features.hasFeature(
                                Features.CreatePayments,
                                this.props.user
                            )}
                            canCreditInvoice={Features.hasFeature(
                                Features.CreditInvoice,
                                this.props.user
                            )}
                            totals={this.props.invoices.totals}
                        />
                    </Row>
                )}
                {this.state.displayViewPaymentsModal && (
                    <ViewPaymentsModal
                        invoiceId={this.state.selectedInvoice}
                        closeModal={() => this.disableModal('displayViewPaymentsModal')}
                    />
                )}
                {this.state.displayShowInvoiceModal && (
                    <ViewCustomerInvoiceModal
                        invoiceId={this.state.selectedInvoice}
                        closeModal={() => this.disableModal('displayShowInvoiceModal')}
                    />
                )}
                {this.state.displayCreatePaymentModal && (
                    <CreatePaymentModal
                        invoiceId={this.state.selectedInvoice}

                        paymentDate={this.state.paymentModalDate}
                        selectDate={this.paymentModalSelectDate}
                        paymentAmount={this.state.paymentModalAmountValue}
                        modalAmountValueChange={this.modalAmountValueChange}

                        closeModal={(reloadList?: boolean) => {
                            this.disableModal('displayCreatePaymentModal');
                            if (reloadList) {
                                this.search();
                            }
                        }}
                    />
                )}
                {this.state.displayCreditInvoiceModal && (
                    <CreditInvoiceModal
                        invoiceId={this.state.selectedInvoice}
                        invoiceDate={new Date()}
                        onCreate={() => this.search()}
                        closeModal={() => this.disableModal('displayCreditInvoiceModal')}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        user: state.user,
        filter: state.invoices.invoicesFilter,
        invoices: state.invoices.invoices
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getInvoices: (filter) => dispatch(actions.getInvoices(filter)),
            getInvoicesFilter: () => dispatch(actions.getInvoicesFilter()),
            downloadInvoice: (id) => dispatch(actions.downloadInvoice(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceHistoryPage));
